const Hero = () => {
  // Get the launch app URL from environment variables
  // Defaults to production URL if not set
  const launchAppUrl =
    import.meta.env.VITE_LAUNCH_APP_URL || 'https://app.trakstr.com'

  return (
    <section
      className="relative overflow-hidden min-h-screen flex flex-col"
      style={{ backgroundColor: 'var(--bg-main)' }}
    >
      {/* Navigation Bar */}
      <nav className="w-full py-4 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center">
            <img src="/logo.png" alt="TrakStr Logo" className="h-8 w-auto" />
          </div>
          <a
            href={launchAppUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Launch App
          </a>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="flex-1 flex items-center">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32 w-full">
          <div className="text-center max-w-4xl mx-auto">
            {/* Logo */}
            <div className="mb-8 fade-in">
              <img
                src="/logo.png"
                alt="TrakStr Logo"
                className="mx-auto h-20 w-auto"
              />
            </div>
            <h1
              className="text-5xl md:text-6xl font-bold mb-6 fade-in"
              style={{ color: 'var(--text-main)' }}
            >
              TrakStr
              <span className="block" style={{ color: 'var(--link-main)' }}>
                Time Tracking
              </span>
            </h1>
            <p
              className="text-xl mb-8 fade-in max-w-3xl mx-auto"
              style={{ color: 'var(--text-main2)', animationDelay: '0.2s' }}
            >
              Self-hostable time tracking application with ActivityWatch
              integration. Take control of your time tracking with a
              privacy-focused, self-hostable solution.
            </p>
            <div
              className="flex justify-center fade-in"
              style={{ animationDelay: '0.4s' }}
            >
              <button className="btn btn-primary btn-lg">Get Started</button>
            </div>
          </div>
        </div>
      </div>

      {/* TrakStr Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div
          className="absolute top-20 left-10 w-20 h-20 rounded-full"
          style={{ backgroundColor: 'var(--btn-main)', opacity: 0.1 }}
        ></div>
        <div
          className="absolute top-40 right-20 w-16 h-16 rounded-full"
          style={{ backgroundColor: 'var(--link-main)', opacity: 0.2 }}
        ></div>
        <div
          className="absolute bottom-20 left-1/4 w-12 h-12 rounded-full"
          style={{ backgroundColor: 'var(--btn-main2)', opacity: 0.15 }}
        ></div>
        <div
          className="absolute bottom-40 right-1/3 w-8 h-8 rounded-full"
          style={{ backgroundColor: 'var(--text-main)', opacity: 0.1 }}
        ></div>
      </div>
    </section>
  )
}

export default Hero
